import React, { useEffect, useState } from "react";
import { message, Table } from "antd";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { download_active_customers, get_billing_report_export, patientwise_report } from "../../endpoints/API";
import { fetchData as apiFetchData } from "../../endpoints/API";

const formatDateTime = (dateString) => {
  if (!dateString) return "N/A";
  return dayjs(dateString).format("DD-MM-YYYY h:mm A");
};

const Monitoring = () => {


  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [data4, setData4] = useState([]);
  const [data5, setData5] = useState([]);
  const [data6, setData6] = useState([]);
  const [data7, setData7] = useState([]);
  const [data8, setData8] = useState([]);
  const [data9, setData9] = useState([]);
  const [data10, setData10] = useState([]);
  const [data11, setData11] = useState([]);
  const [data12, setData12] = useState([]);
  const [data13, setData13] = useState([]);
  const [data17, setData17] = useState([]);
  const [data18, setData18] = useState([]);
  const [data19, setData19] = useState([]);
  const [data20, setData20] = useState([]);
  const [data21, setData21] = useState([]);
  const [data22, setData22] = useState([]);
  const [data24, setData24] = useState([]);
  const [data25, setData25] = useState([]);
  const [data26, setData26] = useState([]);
  const [data27, setData27] = useState([]);
  const [data28, setData28] = useState([]);
  const [data29, setData29] = useState([]);
  const [data30, setData30] = useState([]);

  useEffect(() => {
    const fetchData = async (url, setter) => {
      try {
        const data = await apiFetchData(url);
        setter(data);
      } catch (error) {
        message.error(error?.response?.data?.error);
      }
    };
    fetchData(`we_not_accepted_5min/`, setData);
    fetchData(`we_not_accepted_30min/`, setData2);
    fetchData(`we_arrived_late_30min/`, setData3);
    fetchData(`handover_pending_late_30min/`, setData4);
    fetchData(`report_tat_minus_15min/`, setData5);
    fetchData(`report_tat_more_than_30min/`, setData6);
    fetchData(`total_booked/`, setData7);
    fetchData(`todays_pending/`, setData8);
    fetchData(`todays_booked/`, setData9);
    fetchData(`yesterdays_pending/`, setData10);
    fetchData(`month_till_date/`, setData11);
    fetchData(`total_accepted/`, setData12);
    fetchData(`todays_handover/`, setData13);
    fetchData(`pending-reports/`, setData17);
    fetchData(`todays-cancelled/`, setData18);
    fetchData(`admin-get-all-active-customers/`, setData19);
    fetchData(`repeat-customers/`, setData20);
    fetchData(`todays-cash-collected/`, setData21);
    fetchData(`todays-reschedule/`, setData22);
    fetchData(`get-downloads-app/`, setData24);
    fetchData(`orders_payment_summary/`, setData25);
    fetchData(`we_order_not_accepted/`, setData27);
    fetchData(`mtd_we_order_not_accepted/`, setData28);
    fetchData(`todays_tat_failure_records/`, setData29);
    fetchData(`mtd_tat_failure_records/`, setData30);

    const fetchPatientwiseReport = async () => {
      try {
        const response = await get_billing_report_export();
        setData26(response.data|| []);
      } catch (error) {
        message.error(error?.response?.data?.error || "Failed to fetch patientwise report");
      }
    };

    fetchPatientwiseReport();

  }, []);

  useEffect(() => {
    const interval = setInterval(() => window.location.reload(), 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const transformData = (arr) => {
    if (!Array.isArray(arr)) return [];
    return arr.map((order, idx) => {
      const items = order.order_item || [];
      const members = items.map(i => i.familymember).filter(Boolean);
      const names = members.map(m => `${m.first_name || ''} ${m.middle_name || ''} ${m.last_name || ''}`.trim()).join(', ');
      const phones = members.map(m => m.phone || '-').join(', ');
      const first = items[0] || {};
      return {
        "Order No.": order.order_number || `ORD-${idx + 1}`,
        "Order Date Time": formatDateTime(order.place_datetime),
        Status: order.order_status,
        "Patient Names": names,
        "Phone Numbers": phones,
        "Scheduled Date Time": order.schedule_datetime ? formatDateTime(order.schedule_datetime) : '',
        "Accepted Date Time": order.accepted_datetime ? formatDateTime(order.accepted_datetime) : '',
        "WE Name": order.wellness_executive ? `${order.wellness_executive.first_name} ${order.wellness_executive.last_name}`.trim() : '',
        "Pickup Date Times": first.sample_collect_datetime ? formatDateTime(first.sample_collect_datetime) : '',
        "Handover Date Times": first.sample_handover_datetime ? formatDateTime(first.sample_handover_datetime) : '',
        "Accession Date Time": order.patient_accessions?.[0]?.status_updated_at ? formatDateTime(order.patient_accessions[0].status_updated_at) : '',
        "Report Date Times": first.report_datetime ? formatDateTime(first.report_datetime) : '',
        "Lab Names": items[0]?.test?.lab?.name || '',
        "Pay Type": order.paymentMode,
        Amount: order.transactions?.[0]?.total || 0,
        "Discount Code": order.coupon_applied ? `${order.coupon_applied.discount_value}/${order.coupon_applied.code}` : '',
        "Test/Package Names": items.map(i => i.test?.name).join(', '),
      };
    });
  };

  const sums = {
    sum7: data7.reduce((t, o) => t + o.order_item.reduce((a, i) => a + Number(i.test?.mrp || 0), 0), 0),
    sum8: data8.reduce((t, o) => t + o.order_item.reduce((a, i) => a + Number(i.test?.mrp || 0), 0), 0),
    sum10: data10.reduce((t, o) => t + o.order_item.reduce((a, i) => a + Number(i.test?.mrp || 0), 0), 0),
    sum11: data11.reduce((t, o) => t + o.order_item.reduce((a, i) => a + Number(i.test?.mrp || 0), 0), 0),
    sum12: data12.reduce((t, o) => t + o.order_item.reduce((a, i) => a + Number(i.test?.mrp || 0), 0), 0),
    sum13: data13.reduce((t, o) => t + o.order_item.reduce((a, i) => a + Number(i.test?.mrp || 0), 0), 0),
    sum18: data18.reduce((t, o) => t + o.order_item.reduce((a, i) => a + Number(i.test?.mrp || 0), 0), 0),
    sum21: data21.reduce((t, o) => t + o.order_item.reduce((a, i) => a + Number(i.test?.mrp || 0), 0), 0),
    sum22: data22.reduce((t, o) => t + o.order_item.reduce((a, i) => a + Number(i.test?.mrp || 0), 0), 0),
  };

  const data14 = [...data7, ...data12];
  const data15 = [...data10, ...data11];
  const data16 = [...data7, ...data13];
  const data23 = [...data18, ...data22];

  const exportToExcel = (arr, name) => {
    if (!arr?.length) return message.error("No data available for export!");
    const ws = XLSX.utils.json_to_sheet(transformData(arr));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, name);
    XLSX.writeFile(wb, `${name}.xlsx`);
  };


  const downloadActiveCustomers = async () => {
    try {
      const customerIds = data19?.map((customer) => customer.id);

      const response = await download_active_customers(customerIds);

      if (!response.statusText == "OK") {
        message.error("Failed to download file");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "active_customers.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error(error?.response?.data?.error || "Download failed");
    }
  };

  const downloadRepeatCustomers = async () => {
    try {
      const customerIds = data20?.map((customer) => customer.id);

      const response = await download_active_customers(customerIds);

      if (!response.statusText == "OK") {
        message.error("Failed to download file");
        return;
      }
      const blob = await response?.data;
      const url = window.URL.createObjectURL(blob);
      console.log(url)
      const a = document.createElement("a");
      a.href = url;
      a.download = "active_customers.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url); // cleanup
    } catch (error) {
      message.error(error?.response?.data?.error || "Download failed");
    }
  };

  const exportPatientwiseReport = (arr) => {
    if (!arr?.length) {
      message.error("No data available for Patientwise Report!");
      return;
    }

    // Format the data nicely
    const formatted = arr.map((item) => ({
      "Order Number": item.order_number,
      // "Placed Date": item.place_date ? dayjs(item.place_date).format("DD/MM/YYYY hh:mm A") : "-",
      "Scheduled Date": item.schedule_date_time ? dayjs(item.schedule_date_time).format("DD/MM/YYYY hh:mm A") : "-",
      "Patient Name": item.patient_name || "-",
      "Patient Gender": item.patient_gender || "-",
      "Patient Phone": item.patient_phone || "-",
      "Test ID": Array.isArray(item.test_id) ? item.test_id.join(", ") : item.test_id || "-",
      "Test Name": Array.isArray(item.test_name) ? item.test_name.join(", ") : item.test_name || "-",
      "Test Amount": item.test_amount || "-",
      "Discount": item.discount || "-",
      "B2B Total": item.b2b_total || "-",
      "Total Receivables": item.total_receivables || "-",
      "Wellness Executive": item.wellness_executive || "-",
      "Lab Name": item.lab || "-",
    }));

    // Convert JSON to Excel sheet
    const ws = XLSX.utils.json_to_sheet(formatted);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Patientwise Report");

    // Trigger download
    XLSX.writeFile(wb, "Patientwise_Report.xlsx");
  };
  const patientCount = new Set(
    data26.flatMap(item =>
      item.patient_name
        ? item.patient_name.split(",").map(p => p.trim()).filter(Boolean)
        : []
    )
  ).size;


  return (
    <>
      <header className="font-semibold text-center text-xl md:text-2xl bg-black text-white py-2">
        LIVE PERFORMANCE MONITORING
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full px-2 md:px-0">
        <section className="bg-[#DF9B6D] p-4 text-center rounded-lg">
          <h2 className="text-white text-lg font-semibold mb-2">DISTRESS ORDERS</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {[
              { label: "WE Not Accepted [>5 mins]", count: data.length, onClick: () => exportToExcel(data, "WE_not_accepted_>_5min") },
              { label: "WE Not Accepted [>30 mins]", count: data2.length, onClick: () => exportToExcel(data2, "WE_not_accepted_>_30min") },
              { label: "WE Not Arrived [>30 Mins]", count: data3.length, onClick: () => exportToExcel(data3, "WE_not_arrived_>_30min") },
              { label: "Handover Pending @lab [>30 Mins]", count: data4.length, onClick: () => exportToExcel(data4, "handover_pending_late_30min") },
              { label: "Report TAT-15 Mins", count: data5.length, onClick: () => exportToExcel(data5, "report_tat_minus_15min") },
              { label: "Report TAT> 1 Hour", count: data6.length, onClick: () => exportToExcel(data6, "report_tat_more_than_30min") },
              { label: "WE Order Not Accepted Today/ MTD", count: `${data27.length}/${data28.length}`, onClick: () => exportToExcel(data28, "WE_Order_Not_Accepted") },
              { label: "TAT Failure Report Today/ MTD", count: `${data29.length}/${data30.length}`, onClick: () => exportToExcel(data30, "TAT_Failure_Report") },
            ].map((item, idx) => (
              <div key={idx} className="relative">
                <button onClick={item.onClick} className="bg-red-700 text-white p-1 text-xs md:text-sm shadow-lg z-10 w-11/12 mx-auto font-semibold h-8 rounded">
                  {item.label}
                </button>
                <div className="bg-gray-600 text-white h-20 flex items-center justify-center mt-[-0.7rem] rounded">
                  <div className="font-semibold text-xl border-b border-gray-300 w-full mt-4 mb-4">{item.count}</div>
                </div>
              </div>
            ))}
          </div>
        </section>
        <section className="bg-[#1976D2] p-4 text-center rounded-lg">
          <h2 className="text-white text-lg font-semibold mb-2">DAILY OPERATION MONITORING</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {[
              { label: "Today's Booking/Accepted", count: `${data7.length}/${data12.length}`, value: `₹${sums.sum7}/₹${sums.sum12}`, onClick: () => exportToExcel(data14, "total_booked_accepted") },
              { label: "Yesterday/MTD Booked", count: `${data10.length}/${data11.length}`, value: `₹${sums.sum10}/₹${sums.sum11}`, onClick: () => exportToExcel(data15, "yesterday_mtd_booked") },
              { label: "Today's Pending", count: data8.length, value: `₹${sums.sum8}`, color: "bg-red-700", onClick: () => exportToExcel(data8, "todays_pending") },
              { label: "Today's Booked/Handover", count: `${data7.length}/${data13.length}`, onClick: () => exportToExcel(data16, "todays_booked_handover") },
              { label: "Today's Handover", value: `₹${sums.sum13}`, color: "bg-red-700", onClick: () => exportToExcel(data13, "todays_handover") },
              { label: "Pending Reports", count: data17.length, color: "bg-red-700", onClick: () => exportToExcel(data17, "pending_report") },
              { label: "Today's Cancelled/Rescheduled", count: `${data18.length}/${data22.length}`, value: `₹${sums.sum18}/₹${sums.sum22}`, onClick: () => exportToExcel(data23, "todays_cancelled_and_reschedule") },
              { label: "Active Users", count: data19.length, onClick: downloadActiveCustomers },
              {
                label: "Android / iOS",
                count: `${parseInt(data24?.play_store || 0)} / ${parseInt(data24?.app_store || 0)}`,
                value: `${parseInt(data24?.play_store || 0) + parseInt(data24?.app_store || 0)}`,
              },
              { label: "Today's Cash Collected", count: sums.sum21, onClick: () => exportToExcel(data21, "todays_cash_collected") },
              {
                label: "Total Paid Orders (Online/Offline)",
                count: `${data25?.online?.count || 0} / ${data25?.offline?.count || 0}`,
                value: `₹${String(data25?.online?.amount || 0)} /₹${String(data25?.offline?.amount || 0)}`
              },
              { label: "Repeat Customers %", count: ((data20.length / data19.length) * 100).toFixed(1) + "%", onClick: downloadRepeatCustomers },
              {
                label: "Total Patient Count/Total patient orders",
                count: `${patientCount}/${data26.length}`,
                onClick: () => exportPatientwiseReport(data26)
              },

            ].map((item, idx) => (
              <div key={idx} className="relative">
                <button onClick={item.onClick} className={`${item.color || 'bg-[#0D47A1]'} text-white p-1 text-xs md:text-sm shadow-lg z-10 w-11/12 mx-auto font-semibold h-8 rounded`}>
                  {item.label}
                </button>
                <div className="bg-gray-600 text-white flex flex-col items-center justify-center mt-[-0.7rem] h-20 rounded">
                  <div className="font-semibold text-xl border-b border-gray-300 w-full mt-4">{item.count}</div>
                  {item.value !== undefined && (<div className="text-lg md:text-xl font-semibold mt-1">{item.value}</div>)}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default Monitoring;




// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
// import { message, Table } from "antd";
// import dayjs from "dayjs";
// import * as XLSX from "xlsx";
// import { token } from "../../constants/Constants";

// const formatDateTime = (dateString) => {
//   if (!dateString) return "N/A";
//   return dayjs(dateString).format("DD-MM-YYYY h:mm A"); // Example: 20-03-2025 4:48 PM
// };

// const Monitoring = () => {
//   const baseUrl = useSelector(selectBaseUrl);
//   const prodTestUrl = useSelector(selectProdTestUrl);
//   const [data, setData] = useState([]);
//   const [data2, setData2] = useState([]);
//   const [data3, setData3] = useState([]);
//   const [data4, setData4] = useState([]);
//   const [data5, setData5] = useState([]);
//   const [data6, setData6] = useState([]);
//   const [data7, setData7] = useState([]);
//   const [data8, setData8] = useState([]);
//   const [data9, setData9] = useState([]);
//   const [data10, setData10] = useState([]);
//   const [data11, setData11] = useState([]);
//   const [data12, setData12] = useState([]);
//   const [data13, setData13] = useState([]);
//   const [data17, setData17] = useState([]);
//   const [data18, setData18] = useState([]);
//   const [data19, setData19] = useState([]);
//   const [data20, setData20] = useState([]);
//   const [data21, setData21] = useState([]);
//   const [data22, setData22] = useState([]);
//   const [data24, setData24] = useState([]);

//   console.log(data24);

//   useEffect(() => {
//     const fetchData = async (url, setData) => {
//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`, // Include the token here
//           },
//         });
//         const result = await response.json();
//         setData(result);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     const apiUrl = prodTestUrl || baseUrl;
//     fetchData(`${apiUrl}/api/we_not_accepted_5min/`, setData);
//     fetchData(`${apiUrl}/api/we_not_accepted_30min/`, setData2);
//     fetchData(`${apiUrl}/api/we_arrived_late_30min/`, setData3);
//     fetchData(`${apiUrl}/api/handover_pending_late_30min/`, setData4);
//     fetchData(`${apiUrl}/api/report_tat_minus_15min/`, setData5);
//     fetchData(`${apiUrl}/api/report_tat_more_than_30min/`, setData6);
//     fetchData(`${apiUrl}/api/total_booked/`, setData7);
//     fetchData(`${apiUrl}/api/todays_pending/`, setData8);
//     fetchData(`${apiUrl}/api/todays_booked/`, setData9);
//     fetchData(`${apiUrl}/api/yesterdays_pending/`, setData10);
//     fetchData(`${apiUrl}/api/month_till_date/`, setData11);
//     fetchData(`${apiUrl}/api/total_accepted/`, setData12);
//     fetchData(`${apiUrl}/api/todays_handover/`, setData13);
//     fetchData(`${apiUrl}/api/pending-reports/`, setData17);
//     fetchData(`${apiUrl}/api/todays-cancelled/`, setData18);
//     fetchData(`${apiUrl}/api/admin-get-all-active-customers/`, setData19);
//     fetchData(`${apiUrl}/api/repeat-customers/`, setData20);
//     fetchData(`${apiUrl}/api/todays-cash-collected/`, setData21);
//     fetchData(`${apiUrl}/api/todays-reschedule/`, setData22);
//     fetchData(`${apiUrl}/api/get-downloads-app/`, setData24);
//   }, [baseUrl, prodTestUrl]);

//   // Auto-refresh every 5 minutes
//   useEffect(() => {
//     const interval = setInterval(() => {
//       window.location.reload();
//     }, 5 * 60 * 1000); // 5 minutes

//     return () => clearInterval(interval);
//   }, []);
//   const transformData = (data) => {
//     if (!Array.isArray(data)) return [];

//     return data.map((order, index) => {
//       const wellness_executive = order.wellness_executive;
//       const orderItems = order?.order_item || [];

//       // Get all family members
//       const familyMembers = orderItems
//         .map((item) => item.familymember)
//         .filter((member) => member); // Filter out undefined/null members

//       // Extract family members' names
//       const patientNames = familyMembers
//         .map((patient) =>
//           `${patient?.first_name || ""} ${patient?.middle_name || ""} ${patient?.last_name || ""
//             }`.trim()
//         )
//         .join(", ");

//       // Extract phone numbers
//       const phoneNumbers = familyMembers
//         .map((patient) => patient?.phone || "-")
//         .join(", ");

//       const testNames = orderItems.map((i) => i.test?.name).join(", ")
//         ? orderItems.map((i) => i.test?.name).join(", ")
//         : "";
//       const pickupTimes = orderItems[0]?.sample_collect_datetime
//         ? formatDateTime(orderItems[0]?.sample_collect_datetime)
//         : "";
//       const handoverTimes = orderItems[0]?.sample_handover_datetime
//         ? formatDateTime(orderItems[0]?.sample_handover_datetime)
//         : "";

//       const reportTimes = orderItems[0]?.report_datetime
//         ? formatDateTime(orderItems[0]?.report_datetime)
//         : "";

//       return {
//         "Order No.": order?.order_number || `ORD-${index + 1}`,
//         "Order Date Time": formatDateTime(order?.place_datetime),
//         Status: order?.order_status,
//         "Patient Names": patientNames, // Now includes ALL family members
//         "Phone Numbers": phoneNumbers, // Now includes ALL phone numbers
//         "Scheduled Date Time": order?.schedule_datetime
//           ? formatDateTime(order?.schedule_datetime)
//           : "",
//         "Accepted Date Time": order?.accepted_datetime
//           ? formatDateTime(order?.accepted_datetime)
//           : "",
//         "WE Name": wellness_executive
//           ? `${wellness_executive?.first_name || ""} ${wellness_executive?.middle_name || ""
//             } ${wellness_executive?.last_name || ""}`.trim()
//           : "",
//         "Pickup Date Times": pickupTimes,
//         "Handover Date Times": handoverTimes,
//         "Accession Date Time": order?.patient_accessions?.[0]?.status_updated_at
//           ? formatDateTime(order?.patient_accessions?.[0]?.status_updated_at)
//           : "",
//         "Report Date Times": reportTimes,
//         "Lab Names":
//           orderItems.length > 0 ? orderItems[0]?.test?.lab?.name : "",
//         "Pay Type": order?.paymentMode,
//         Amount: `${order?.transactions?.[0]?.total || 0}`,
//         "Discount Code": order?.coupon_applied
//           ? `${order?.coupon_applied?.discount_value || ""}/${order?.coupon_applied?.code
//           }`
//           : "",
//         "Test/Package Names": testNames,
//       };
//     });
//   };

//   const transformedData = transformData(data);
//   const transformedData2 = transformData(data2);
//   const transformedData3 = transformData(data3);
//   const transformedData4 = transformData(data4);
//   const transformedData5 = transformData(data5);
//   const transformedData6 = transformData(data6);
//   const transformedData7 = transformData(data7);
//   const transformedData8 = transformData(data8);
//   const transformedData9 = transformData(data9);
//   const transformedData10 = transformData(data10);
//   const transformedData11 = transformData(data11);
//   const transformedData12 = transformData(data12);
//   const transformedData13 = transformData(data13);
//   const transformedData14 = transformData([...data7, ...data12]);
//   const transformedData15 = transformData([...data10, ...data11]);
//   const transformedData16 = transformData([...data9, ...data13]);
//   const data14 = [...data7, ...data12];
//   const data15 = [...data10, ...data11];
//   const data16 = [...data7, ...data13];
//   const data23 = [...data18, ...data22];

//   const exportToExcel = (data, fileName) => {
//     if (!data || data.length === 0) {
//       message.error("No data available for export!");
//       return;
//     }

//     const transformed = transformData(data);
//     const worksheet = XLSX.utils.json_to_sheet(transformed);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, fileName);
//     XLSX.writeFile(workbook, `${fileName}.xlsx`);
//   };

//   const downloadActiveCustomers = async () => {
//     try {
//       const customerIds = data19?.map((customer) => customer.id);

//       const response = await fetch(
//         `${prodTestUrl || baseUrl}/api/download-active-customers/`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ ids: customerIds }),
//         }
//       );

//       if (!response.ok) {
//         message.error("Failed to download file");
//         return;
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = "active_customers.xlsx";
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url); // cleanup
//     } catch (error) {
//       console.error("Error downloading active customers:", error);
//       message.error("Download failed");
//     }
//   };

//   const downloadRepeatCustomers = async () => {
//     try {
//       const customerIds = data20?.map((customer) => customer.id);

//       const response = await fetch(
//         `${prodTestUrl || baseUrl}/api/download-active-customers/`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ ids: customerIds }),
//         }
//       );

//       if (!response.ok) {
//         message.error("Failed to download file");
//         return;
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = "active_customers.xlsx";
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url); // cleanup
//     } catch (error) {
//       console.error("Error downloading active customers:", error);
//       message.error("Download failed");
//     }
//   };

//   const calculateSum = (data) => {
//     return (
//       data?.reduce((total, entry) => {
//         const entrySum = entry?.order_item?.reduce((itemTotal, item) => {
//           return itemTotal + (Number(item?.test?.mrp) || 0);
//         }, 0);
//         return total + entrySum;
//       }, 0) || 0
//     );
//   };

//   const sum7 = calculateSum(data7);
//   const sum10 = calculateSum(data10);
//   const sum11 = calculateSum(data11);
//   const sum12 = calculateSum(data12);
//   const sum8 = calculateSum(data8);
//   const sum13 = calculateSum(data13);
//   const sum18 = calculateSum(data18);
//   const sum21 = calculateSum(data21);
//   const sum22 = calculateSum(data22);

//   const column = [
//     {
//       title: "Order Date Time",
//       dataIndex: "place_datetime",
//       key: "place_datetime",
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       key: "status",
//     },
//     {
//       title: "Patient Name",
//       dataIndex: "patient_name",
//       key: "patient_name",
//     },
//     {
//       title: "Phone Number",
//       dataIndex: "phone_number",
//       key: "phone_number",
//     },
//     {
//       title: "Bill ID",
//       dataIndex: "bill_id",
//       key: "bill_id",
//     },
//     {
//       title: "Scheduled Date Time",
//       dataIndex: "scheduled_datetime",
//       key: "scheduled_datetime",
//     },
//     {
//       title: "Accepted Date Time",
//       dataIndex: "accepted_datetime",
//       key: "accepted_datetime",
//     },
//     {
//       title: "WE Name",
//       dataIndex: "we_name",
//       key: "we_name",
//     },
//     {
//       title: "Pickup Date Time",
//       dataIndex: "pickup_datetime",
//       key: "pickup_datetime",
//     },
//     {
//       title: "Handover Date Time",
//       dataIndex: "handover_datetime",
//       key: "handover_datetime",
//     },
//     {
//       title: "Accession Date Time",
//       dataIndex: "accession_datetime",
//       key: "accession_datetime",
//     },
//     {
//       title: "Report Date Time",
//       dataIndex: "report_datetime",
//       key: "report_datetime",
//     },
//     {
//       title: "Reschedule Date Time",
//       dataIndex: "reschedule_datetime",
//       key: "reschedule_datetime",
//     },
//     {
//       title: "Cancel Date Time",
//       dataIndex: "cancel_datetime",
//       key: "cancel_datetime",
//     },
//     {
//       title: "Lab Name",
//       dataIndex: "lab_name",
//       key: "lab_name",
//     },
//     {
//       title: "Pay Type",
//       dataIndex: "pay_type",
//       key: "pay_type",
//     },
//     {
//       title: "Amount",
//       dataIndex: "amount",
//       key: "amount",
//     },
//     {
//       title: "Discount/Coupon Code",
//       dataIndex: "discount_code",
//       key: "discount_code",
//     },
//     {
//       title: "Test/Package Name",
//       dataIndex: "test_package_name",
//       key: "test_package_name",
//     },
//     {
//       title: "Pickup TAT",
//       dataIndex: "pickup_tat",
//       key: "pickup_tat",
//     },
//     {
//       title: "Report TAT",
//       dataIndex: "report_tat",
//       key: "report_tat",
//     },
//   ];

//   return (
//     <>
//       <div className="font-semibold flex justify-center text-2xl bg-black text-white">
//         LIVE PERFORMANCE MONITORING
//       </div>
//       <div className="grid grid-cols-2 w-full">
//         <div className="bg-[#DF9B6D] p-2 text-center">
//           <div className="text-white text-lg font-semibold">
//             DISTRESS ORDERS
//           </div>
//           <div className="grid grid-cols-2 gap-2 mt-1">
//             {[
//               {
//                 label: "WE Not Accepted [>5 mins]",
//                 count: data?.length,
//                 onClick: () => exportToExcel(data, "WE_not_accepted_>_5min"),
//               },
//               {
//                 label: "WE Not Accepted [>30 mins]",
//                 count: data2?.length,
//                 onClick: () => exportToExcel(data2, "WE_not_accepted_>_30min"),
//               },
//               {
//                 label: "WE Not Arrived [>30 Mins]",
//                 count: data3?.length,
//                 onClick: () => exportToExcel(data3, "WE_not_arrived_>_30min"),
//               },
//               {
//                 label: "Handover Pending @lab [>30 Mins]",

//                 count: data4?.length,
//                 onClick: () =>
//                   exportToExcel(data4, "handover_pending_late_30min"),
//               },
//               {
//                 label: "Report TAT-15 Mins",

//                 count: data5?.length,
//                 onClick: () => exportToExcel(data5, "report_tat_minus_15min"),
//               },
//               {
//                 label: "Report TAT> 1 Hour",
//                 count: data6?.length,
//                 onClick: () =>
//                   exportToExcel(data6, "report_tat_more_than_30min"),
//               },
//               // {
//               //   label: "Cash Not Deposited [>24 Hrs]",
//               //   count: "Disabled",
//               // },
//             ].map((item, index) => (
//               <div key={index} className="relative text-center">
//                 <div
//                   onClick={item.onClick}
//                   className="bg-red-700 text-white p-2 text-sm shadow-lg relative z-10 w-[90%] ml-[1rem] font-semibold h-8"
//                 >
//                   {item.label}
//                 </div>
//                 <div className="bg-gray-600 text-white border-white h-20 flex items-center justify-center relative z-0 mt-[-0.7rem]">
//                   <div className="border-gray-300 w-full mt-[1rem] font-semibold text-xl border-b mb-[1.7rem]">
//                     {item.count}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="bg-[#1976D2] p-2 text-center">
//           <div className="text-white text-lg font-semibold">
//             DAILY OPERATION MONITORING
//           </div>
//           <div className="grid grid-cols-2 gap-2 mt-1">
//             {[
//               {
//                 label: "Today's Booking/Accepted",
//                 value: `${sum7 + "/" + sum12}`,
//                 count: `${data7?.length + "/" + data12?.length}`,
//                 onClick: () => exportToExcel(data14, "total_booked_accepted"),
//               },

//               {
//                 label: "Yesterday/MTD Booked",
//                 count: data10?.length + "/" + data11?.length,
//                 onClick: () => exportToExcel(data15, "yesterday_mtd_booked"),
//                 value: `${sum10 + "/" + sum11}`,
//               },
//               {
//                 label: "Today's Pending",
//                 count: data8?.length,
//                 value: `${sum8}`,
//                 onClick: () => exportToExcel(data8, "todays_pending"),
//                 color: "bg-red-700",
//               },
//               {
//                 label: "Today's Booked/Handover",
//                 count: data7?.length + "/" + data13?.length,
//                 value: `${sum7 + "/" + sum13}`,
//                 onClick: () => exportToExcel(data16, "todays_booked_handover"),
//               },
//               {
//                 label: "Pending Reports",
//                 count: data17?.length,
//                 value: "",
//                 color: "bg-red-700",
//                 onClick: () => exportToExcel(data17, "pending_report"),
//               },
//               {
//                 label: "Today's Cancelled/Rescheduled",
//                 count: data18?.length + "/" + data22?.length,
//                 value: `${sum18 + "/" + sum22}`,
//                 onClick: () =>
//                   exportToExcel(data23, "todays_cancelled_and_reschedule"),
//               },
//               {
//                 label: "Active Users",
//                 count: data19?.length,
//                 value: "",
//                 onClick: downloadActiveCustomers,
//               },
//               {
//                 label: "Total App Downloads",
//                 count:
//                   parseInt(data24?.play_store || "0") +
//                   parseInt(data24?.app_store || "0"),
//                 value: "",
//               },

//               {
//                 label: "Today's Cash Collected",
//                 count: `${sum21}`,
//                 value: "",
//                 onClick: () => exportToExcel(data21, "todays_cash_collected"),
//               },
//               {
//                 label: "Repeat Customers %",
//                 count: (data20?.length / data19?.length) * 100 + " " + "%",
//                 value: "",
//                 onClick: downloadRepeatCustomers,
//               },
//             ]?.map((item, index) => (
//               <div key={index} className="relative text-center">
//                 <div
//                   onClick={item.onClick}
//                   className={`${item.color || "bg-[#0D47A1]"
//                     } text-white p-2 text-sm shadow-lg relative z-10 w-[90%] ml-[1rem] font-semibold h-8`}
//                 >
//                   {item.label}
//                 </div>
//                 <div className="bg-gray-600 text-white border-white h-20 flex flex-col items-center justify-center relative z-0 mt-[-0.7rem]">
//                   <div className="border-gray-300 w-full text-xl font-semibold border-b mt-[1rem]">
//                     {item.count}
//                   </div>
//                   <div className="text-xl font-semibold">{item.value}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//       {/* <Table columns={column} dataSource={transformedData} /> */}
//     </>
//   );
// };

// export default Monitoring;
